import {decorate, observable} from "mobx";
import Api from "../util/api";

export default class datastore {

    datas = observable([]);
    tags = observable([]);
    tagsDesImages = observable([]);

    pickAsset;
    total = 0;

    defaultFilter = {
        type: "images",
        search: "",
        status: "",
        page: "0",
        limit: "48",
        last_page: "1",
        tag: "",
        non_utilisees: "",
    }

    filter = {
        type: "images",
        search: "",
        page: "0",
        limit: "48",
        status: "",
        last_page: "1",
        tag: "",
        non_utilisees: "",
    }

    constructor(rootStore) {
        this.rootStore = rootStore;
        this.api = new Api();
    }


    async getDatas() {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            const authResponse = await this.api.images.getImage(this.filter);

            if (this.datas.length > 0) {
                this.datas.replace(authResponse.data)
            } else {
                this.datas = authResponse.data;
            }

            this.filter.page = authResponse.current_page;
            this.filter.last_page = authResponse.last_page;
            this.total = authResponse.total;
            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse.datas
        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async findById(id) {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            const authResponse = await this.api.images.find(id);
            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse.datas;

        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }


    async save(datas, message) {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            let authResponse = await this.api.images.save(datas);

            if (authResponse?.status === "success") {
                this.rootStore.notificationStore.setNotification(message ?? "Images ajouté(e)s", "success");
            }

            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse

        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async saveRelationAsset(datas, message) {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            let authResponse = await this.api.resource.save("relation/assets", datas);

            if (authResponse?.status === "success") {
                this.rootStore.notificationStore.setNotification(message ?? "Images ajouté(e)s", "success");
            }

            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse

        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async updateRelationAsset(datas, message) {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            let authResponse = await this.api.resource.save("updaterelation/assets", datas);

            if (authResponse?.status === "success") {
                this.rootStore.notificationStore.setNotification(message ?? "Images modidié(e)s", "success");
            }

            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse

        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async deleteRelationAsset(datas, message) {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            let authResponse = await this.api.resource.save("delete/relation/assets", datas);

            if (authResponse?.status === "success") {
                this.rootStore.notificationStore.setNotification(message ?? "Images supprimé(e)s", "success");
            }

            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse

        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }


    async saveOne(datas, message) {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            let authResponse = await this.api.images.saveOne(datas);

            if (authResponse?.status === "success") {
                this.rootStore.notificationStore.setNotification(message ?? "Images ajouté(e)s", "success");
            }

            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse

        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async update(datas, message) {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            let authResponse = await this.api.images.update(datas);

            if (authResponse?.status === "success") {
                this.rootStore.notificationStore.setNotification(message ?? "Image #" + authResponse.datas.id + " modifiée", "success");
            }

            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse

        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }


    async delete(id) {
        try {
            this.rootStore.savedDatasStore.setLoading(true)
            let authResponse = await this.api.images.delete(id);

            if (authResponse?.status === "success") {
                this.rootStore.notificationStore.setNotification("Image # " + id + " supprimée", "success");
                this.getDatas()
            }

            this.rootStore.savedDatasStore.setLoading(false)
        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }

    async getAllTags() {
        this.rootStore.savedDatasStore.setLoading(true)
        try {
            const authResponse = await this.api.images.getTags();

            if (this.tags.length > 0) {
                this.tags.replace(authResponse)
            } else {
                this.tags = authResponse;
            }

            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse
        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }


    async createTag(datas, message) {
        this.rootStore.savedDatasStore.setLoading(true)

        try {
            let authResponse = await this.api.images.createTag(datas);

            if (authResponse?.status === "success") {
                this.rootStore.notificationStore.setNotification(message ?? "Tag ajouté", "success");
                this.getAllTags()
            }

            this.rootStore.savedDatasStore.setLoading(false)
            return authResponse.data

        } catch (e) {
            this.rootStore.savedDatasStore.setLoading(false)
        }
    }


    // Médiathèque (images, ou vidéos de l'écran pub quand filter.type vaut « videos »)

    mots() {
        return this.filter.type === "videos"
            ? {une: "Vidéo", supprimees: "vidéos supprimées"}
            : {une: "Image", supprimees: "images supprimées"};
    }

    async chargerTagsDesImages() {
        try {
            this.tagsDesImages = await this.api.images.tagsDesImages(this.filter.type);
        } catch (e) {
            this.tagsDesImages = [];
        }
    }

    async envoyer(fichiers, onProgression) {
        try {
            const reponse = await this.api.images.envoyer(fichiers, onProgression);
            this.rootStore.notificationStore.setNotification(fichiers.length > 1 ? fichiers.length + " images ajoutées" : "Image ajoutée", "success");
            this.filter.page = 1;
            await this.getDatas();
            return reponse.datas ?? [];
        } catch (e) {
            return [];
        }
    }

    // Vidéos de l'écran pub : envoyées une à une, en morceaux (comme depuis l'éditeur de l'écran pub)
    async envoyerVideos(fichiers, onProgression) {
        const ajoutees = [];
        for (let i = 0; i < fichiers.length; i++) {
            try {
                const reponse = await this.api.auth.ajouterVideoPublicite(fichiers[i],
                    p => onProgression && onProgression(Math.round((i * 100 + p) / fichiers.length)));
                if (reponse?.data) ajoutees.push(reponse.data);
            } catch (erreur) {
                const message = typeof erreur === "string" ? erreur : "Vidéo non envoyée";
                this.rootStore.notificationStore.setNotification(fichiers[i].name + " : " + message, "error");
            }
        }
        if (ajoutees.length > 0) {
            this.rootStore.notificationStore.setNotification(ajoutees.length > 1 ? ajoutees.length + " vidéos ajoutées" : "Vidéo ajoutée", "success");
        }
        this.filter.page = 1;
        await this.getDatas();
        return ajoutees;
    }

    async fiche(id) {
        try {
            const reponse = await this.api.images.fiche(id);
            return {...reponse.datas, utilisations: reponse.utilisations ?? []};
        } catch (e) {
            return null;
        }
    }

    async modifier(datas) {
        try {
            const reponse = await this.api.images.modifier(datas);
            this.rootStore.notificationStore.setNotification(this.mots().une + " enregistrée", "success");
            await this.getDatas();
            return reponse.datas;
        } catch (e) {
            return null;
        }
    }

    async supprimer(ids) {
        let supprimees = 0;
        for (const id of ids) {
            try {
                await this.api.images.supprimer(id);
                supprimees++;
            } catch (e) {
                // l'erreur est déjà affichée par l'intercepteur
            }
        }
        if (supprimees > 0) {
            this.rootStore.notificationStore.setNotification(supprimees > 1 ? supprimees + " " + this.mots().supprimees : this.mots().une + " supprimée", "success");
        }
        await this.getDatas();
        return supprimees;
    }

    async ajouterTags(ids, tags) {
        try {
            await this.api.images.ajouterTags(ids, tags);
            this.rootStore.notificationStore.setNotification("Tags ajoutés", "success");
            await this.getDatas();
            return true;
        } catch (e) {
            return false;
        }
    }

    // Crée les tags tapés dans le champ (nouvelles valeurs de CreatableSelect) et renvoie la liste des ids
    async idsDesTags(options) {
        const ids = [];
        for (const option of options ?? []) {
            if (option.__isNew__) {
                const tag = await this.createTag({name: option.label});
                if (tag?.id) ids.push(tag.id);
            } else {
                ids.push(option.value);
            }
        }
        return [...new Set(ids)];
    }
}

decorate(datastore, {
    datas: observable,
    tags: observable,
    search: observable,
    limit: observable,
    currentPage: observable,
    lastPage: observable,
    pickAsset: observable,
    total: observable,
    tagsDesImages: observable,
    filter: observable,
    defaultFilter: observable
});

